import * as React from 'react';
import { Link, Redirect } from 'react-router-dom';
import LoginServices from '../../../services/LoginServices';

export interface Props {
}

interface State {
    redirect: boolean;
}

/**
 * le bouton deconnection de la page de l'admin
 */
export class ButtonDeconnect extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        this.state = { redirect: false };
    }

    callLogout = () => {
        const loginServices = LoginServices.getInstance();
        loginServices.logout().then(
            response => {
                this.setState({redirect: true});
            }
        ).catch(
            error => {
                this.setState({redirect: true});
            }
        );
    }

    render() {
        if (this.state.redirect) {
            return ( <Redirect to="/" />);
        }
        const btnStyle = {
            border: 'none',
            textAlign : 'center',
            textDecoration: 'none',
            display: 'inline-block',
            fontSize: '20px',
            paddingTop: '20px',
            cursor: 'pointer',
            marginLeft: '1cm'
        };
        const logoStyle = {
            paddingRight: '10px',
            paddingBottom: '5px',
        };

        return (
            <nav className="navbar navbar-expand-sm">
                <Link className="navbar-brand" to="/home">
                    <img
                        src={require('./logo-chorinitia-1.jpg')}
                        className="img-responsive"
                        height="80px"
                        alt="Logo"
                    />
                </Link>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        <button
                            className="btn-outline-light nav-link text-black-50"
                            style={btnStyle}
                            onClick={this.callLogout}
                        >
                            <img
                                style={logoStyle}
                                src={require('../../genericComponents/Images/power.png')}
                                className="img-responsive"
                                alt="Logo"
                            />
                            Se déconnecter
                        </button>
                    </ul>
                </div>
            </nav>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SuperAdminPage/internalComponents/ButtonDeconnect.tsx